// extracted by mini-css-extract-plugin
export default {"MktLangSelect":"o_lJ9aB","vocConsent":"VaZtjUt","subMitButton":"pRmhzHG","markdown":"zIsqgg4"};